import { render } from "./Card1.vue?vue&type=template&id=18f1e892"
import script from "./Card1.vue?vue&type=script&lang=js"
export * from "./Card1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__